import React, { FC } from 'react';
import { Box } from '@mui/material';
import {
  PerformanceReviewType,
  BasePerformanceReview,
  PerformanceSummary,
} from '../performance.interfaces';
import PerformanceStudentsView from '../subviews/performanceStudents.view';
import PerformanceStaffView from '../subviews/performanceStaff.view';
import PerformanceExternalView from '../subviews/performanceExternal.view';

interface PerformanceViewSelectorProps {
  reviewType: PerformanceReviewType;
  filteredReviews: BasePerformanceReview[];
  currentSummary: PerformanceSummary;
  onReviewSelect: (review: any) => void;
}

const PerformanceViewSelector: FC<PerformanceViewSelectorProps> = ({
  reviewType,
  filteredReviews,
  currentSummary,
  onReviewSelect,
}) => {
  return (
    <Box data-testid="performance-view-selector">
      {(() => {
        switch (reviewType) {
          case PerformanceReviewType.STUDENTS:
            return (
              <PerformanceStudentsView
                reviews={filteredReviews as any}
                summary={currentSummary}
                onReviewSelect={onReviewSelect}
              />
            );
          case PerformanceReviewType.STAFF:
            return (
              <PerformanceStaffView
                reviews={filteredReviews as any}
                summary={currentSummary}
                onReviewSelect={onReviewSelect}
              />
            );
          case PerformanceReviewType.EXTERNAL:
            return (
              <PerformanceExternalView
                reviews={filteredReviews as any}
                summary={currentSummary}
                onReviewSelect={onReviewSelect}
              />
            );
          default:
            return null;
        }
      })()}
    </Box>
  );
};

export default PerformanceViewSelector;
